export const normalize = (str) => { // Ggf. spezifischerer Name
    if (typeof str !== 'string') return ''; // Absicherung
    return str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
};